export default __webpack_public_path__ + "static/media/header-logo.affc0470.svg";